var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",_vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])}))],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",_vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()}),{"row":item})],2)}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e9c0e8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/theme/Table.vue
// module id = null
// module chunks = 